import { z } from 'zod';
import { schemaIdentifiant, schemaNouveauMotDePasse } from './auth';

export const schemaActivationContexte = z.object({
  appartenance_id: z.string().uuid(),
});

export const schemaCreationUtilisateur = z.object({
  identifiant: schemaIdentifiant,
  nom: z.string().trim().min(1).max(120),
  prenoms: z.string().trim().max(200).optional(),
  courriel: z.string().trim().email('Courriel invalide').optional(),
  telephone: z
    .string()
    .trim()
    .regex(/^\+?[0-9 ]{6,20}$/, 'Téléphone invalide')
    .optional(),
  mot_de_passe_initial: schemaNouveauMotDePasse,
});

export const schemaInvitation = z.object({
  motif: z.string().trim().max(500).optional(),
});

/** Modules M01 à M25 (cahier des charges). */
export const MODULES = {
  M01: 'Tableau de bord du maire ou du président',
  M02: 'Administration générale',
  M03: 'Gestion électronique des documents',
  M04: 'Portail citoyen',
  M05: 'Moteur de démarches',
  M06: 'Finances et budget',
  M07: 'Taxes locales et redevances',
  M08: 'Marchés municipaux',
  M09: 'Occupation du domaine public',
  M10: 'Patrimoine',
  M11: 'Ressources humaines',
  M12: 'Interventions',
  M13: 'Déchets et propreté',
  M14: 'Travaux et chantiers',
  M15: 'Marchés publics et fournisseurs',
  M16: 'Conseils municipaux et départementaux',
  M17: 'Quartiers et participation',
  M18: 'Urbanisme et aménagement',
  M19: 'Équipements publics',
  M20: 'Actions sociales',
  M21: 'Événements et vie locale',
  M22: 'Réclamations et satisfaction',
  M23: 'Inspections et contrôles',
  M24: 'Supervision nationale',
  M25: 'Administration et paramétrage',
} as const;
export type CodeModule = keyof typeof MODULES;
export const CODES_MODULES = Object.keys(MODULES) as CodeModule[];

export const schemaModificationModule = z.object({
  module: z.enum(Object.keys(MODULES) as [CodeModule, ...CodeModule[]]),
  actif: z.boolean(),
  motif: z.string().trim().min(3, 'Motif obligatoire').max(500),
});
